/*jslint browser: true */
/*global window:false, AdminPhoto:false, ko:false */

;(function () {
    "use strict";

    window.ObjectTagsViewModel = function (options) {
        var model;

        model = this;
        model.hasItems = ko.observable(true);
        model.hasNext = ko.observable(false);
        model.hasPrev = ko.observable(false);
        model.object = ko.observable(null);
        model.error = ko.observable(null);
        model.progress = ko.observable(true);

        var ObjectTag = window.CreateObjectTagClass(model, options);
        model.activeTags = ko.observableArray([]);
        model.rootTag = ObjectTag.Root;
        model.allTags = ObjectTag.All;
        model.hasVisibleTags = ObjectTag.HasVisibleTags;

        TagObject.Init(options);
    };
})();